import NetxQueryClient, {
	type SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {getResponseResults} from '@netx/core-next/utils/api';

/**
 * `removeAttributeVocabularyValue` request params
 * (what is used to send to server)
 */

export type RemoveAttributeVocabularyValueRequestOptions = {
	id: number;
};

/**
 * `removeAttributeVocabularyValue` request
 * (what removes sent to the server)
 */
export type RemoveAttributeVocabularyValueRequest = [
	RemoveAttributeVocabularyValueRequestOptions['id'],
];

/**
 * `removeAttributeVocabularyValue` response
 * (what comes back from the server)
 */
export type RemoveAttributeVocabularyValueResponse = SuccessResponse<boolean>;

/**
 * `removeAttributeVocabularyValue` result
 * (what is utilized from the server response)
 */
export type RemoveAttributeVocabularyValueResult = number;

export const removeAttributeVocabularyValueEndpoint =
	'removeAttributeVocabularyValue';

/**
 * Remove attribute vocabularies
 * @param fetchParams Fetch params

 */
export const removeAttributeVocabularyValue = async ({
	id,
}: RemoveAttributeVocabularyValueRequestOptions): Promise<RemoveAttributeVocabularyValueResult> => {
	const client = NetxQueryClient();

	const requestParams: RemoveAttributeVocabularyValueRequest = [id];

	return client
		.post<RemoveAttributeVocabularyValueResponse>(
			removeAttributeVocabularyValueEndpoint,
			requestParams,
			{},
		)
		.then((response) => {
			const result = getResponseResults(response);
			if (!result)
				throw new Error('Unable to remove attribute vocabulary value');
			return id;
		});
};

export default removeAttributeVocabularyValue;
